import { searchConstants } from '../_constants/search.constants';
import {
  setIsFetching,
  resetSearchResults,
  resetSearchText,
  filterSearchResults,
  clearSearchResults,
  updateSearchText
} from '../_utils/search.utils';

const initialState = {
  mainNavs: {
    isFetching: false,
    errorMessage: undefined,
    searchList: {
      fund: 'กองทุน',
      fundInformation: [],
      copyPort: 'COPYPORT',
      copyPortInformation: [],
      modelPort: 'MODELPORT',
      modelPortInformation: [],
      article: 'บทความ',
      articleInformation: []
    },
    searchText: null,
  },
  subNavs: {
    isFetching: false,
    errorMessage: undefined,
    searchList: {
      fund: 'กองทุน',
      fundInformation: [],
      copyPort: 'COPYPORT',
      copyPortInformation: [],
      modelPort: 'MODELPORT',
      modelPortInformation: [],
      article: 'บทความ',
      articleInformation: []
    },
    searchText: null,
  },
  calendarSearch: {
    isFetching: false,
    errorMessage: undefined,
    searchList: {
      fund: 'กองทุน',
      fundInformation: [],
      copyPort: 'COPYPORT',
      copyPortInformation: [],
      modelPort: 'MODELPORT',
      modelPortInformation: [],
      article: 'บทความ',
      articleInformation: []
    },
    searchText: null,
  },
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.FETCH_MAIN_SEARCH_START:
      return {
        ...state,
        mainNavs: setIsFetching(state.mainNavs),
      };
    case searchConstants.FETCH_MAIN_SEARCH_SUCCESS:
      return {
        ...state,
        mainNavs: filterSearchResults(state.mainNavs, action.payload)
      };
    case searchConstants.FETCH_MAIN_SEARCH_FAILURE:
      return {
        ...state,
        mainNavs: resetSearchResults(state.mainNavs, action.payload)
      };
    case searchConstants.CLEAR_MAIN_SEARCH:
      return {
        ...state,
        mainNavs: clearSearchResults(state.mainNavs)
      };
    case searchConstants.UPDATE_MAIN_SEARCH:
      return {
        ...state,
        mainNavs: updateSearchText(state.mainNavs, action.payload)
      };
    case searchConstants.REMOVE_MAIN_SEARCH:
      return {
        ...state,
        mainNavs: resetSearchText(state.mainNavs)
      };
    case searchConstants.FETCH_SUBNAV_SEARCH_START:
      return {
        ...state,
        subNavs: setIsFetching(state.subNavs)
      };
    case searchConstants.FETCH_SUBNAV_SEARCH_SUCCESS:
      return {
        ...state,
        subNavs: filterSearchResults(state.subNavs, action.payload)
      };
    case searchConstants.FETCH_SUBNAV_SEARCH_FAILURE:
      return {
        ...state,
        subNavs: resetSearchResults(state.subNavs, action.payload)
      };
    case searchConstants.CLEAR_SUBNAV_SEARCH:
      return {
        ...state,
        subNavs: clearSearchResults(state.subNavs)
      };
    case searchConstants.UPDATE_SUBNAV_SEARCH:
      return {
        ...state,
        subNavs: updateSearchText(state.subNavs, action.payload)
      };
    case searchConstants.REMOVE_SUBNAV_SEARCH:
      return {
        ...state,
        subNavs: resetSearchText(state.subNavs)
      };
    case searchConstants.FETCH_SEARCH_FUND_CALENDAR_START:
      return {
        ...state,
        calendarSearch: setIsFetching(state.calendarSearch)
      };
    case searchConstants.FETCH_SEARCH_FUND_CALENDAR_SUCCESS:
      return {
        ...state,
        calendarSearch: filterSearchResults(state.calendarSearch, action.payload)
      };
    case searchConstants.FETCH_SEARCH_FUND_CALENDAR_FAILURE:
      return {
        ...state,
        calendarSearch: resetSearchResults(state.calendarSearch, action.payload)
      };
    case searchConstants.CLEAR_SEARCH_FUND_CALENDAR:
      return {
        ...state,
        calendarSearch: clearSearchResults(state.calendarSearch)
      };
    case searchConstants.UPDATE_SEARCH_FUND_CALENDAR:
      return {
        ...state,
        calendarSearch: updateSearchText(state.calendarSearch, action.payload)
      };
    case searchConstants.REMOVE_SEARCH_FUND_CALENDAR:
      return {
        ...state,
        calendarSearch: resetSearchText(state.calendarSearch)
      };
    default:
      return state;
  }
};

export default searchReducer;
